import { Image } from '@mybridge/ui';
import { forwardRef } from 'react';
export const NoMembersFoundIll = forwardRef(({ ...props }, ref) => {
  return <Image src="/nomembersill.png" {...props} />;
});
